import { API_ENDPOINTS, withParams } from '../config/apis';
import { apiRequest } from './client';

export type ManagerRole = 'SUPER' | 'MIDDLE' | 'GENERAL' | 'NORMAL';

export type ManagerProfileResponse = {
  id: number;
  account: string;
  role: ManagerRole;
  email: string;
  contactNumber?: string;
  name?: string;
};

export type ManagerAccount = {
  id: number;
  account: string;
  role: ManagerRole;
  email: string;
  contactNumber?: string;
  name?: string;
};

export type ManagerListResponse = {
  managers: ManagerAccount[];
  totalCount: number;
  page: number;
  size: number;
};

export type ManagerCreateRequest = {
  account: string;
  role: ManagerRole;
  email: string;
  contactNumber?: string;
};

export type ManagerUpdateRequest = {
  role: ManagerRole;
  email: string;
  contactNumber?: string;
};

export type ManagerDuplicateResponse = {
  isDuplicated: boolean;
};

export type ManagerDeleteRequest = {
  managerIds: number[];
};

export function requestMyManagerProfile() {
  return apiRequest<ManagerProfileResponse>(API_ENDPOINTS.managerMine);
}

export function requestManagers(keyword = '', role = '', page = 0, size = 20) {
  return apiRequest<ManagerListResponse>(API_ENDPOINTS.managerList, {
    query: { keyword, role, page, size },
  });
}

export function requestCreateManager(body: ManagerCreateRequest) {
  return apiRequest<ManagerAccount, ManagerCreateRequest>(API_ENDPOINTS.managerCreate, { body });
}

export function requestUpdateManager(managerId: number, body: ManagerUpdateRequest) {
  return apiRequest<ManagerAccount, ManagerUpdateRequest>(
    withParams(API_ENDPOINTS.managerUpdate, { managerId }),
    { body }
  );
}

export function requestCheckManagerAccountDuplicate(account: string) {
  return apiRequest<ManagerDuplicateResponse>(API_ENDPOINTS.managerAccountDuplicate, {
    query: { account },
  });
}

export function requestCheckManagerEmailDuplicate(email: string) {
  return apiRequest<ManagerDuplicateResponse>(API_ENDPOINTS.managerEmailDuplicate, {
    query: { email },
  });
}

export function requestDeleteManagers(managerIds: number[]) {
  return apiRequest<void, ManagerDeleteRequest>(API_ENDPOINTS.managerDelete, {
    body: { managerIds },
  });
}
